export const reduxKey = '@@EDITOR';
export const i18nNamespace = 'editor';
